import { GuestContent, Register as CoreRegister } from '@namespace/auth';
import { useConfig } from '@namespace/cms';
import {
  getCountryIdFromCookie,
  getLocalStorageValue,
  LOCAL_STORAGE_KEYS
} from '@namespace/helpers';
import { registerStepsMap } from './steps/registerStepsMap';
import RegistrationClosed from './RegistrationClosed';

import styles from './index.module.css';

const Register = ({ id }) => {
  const { config } = useConfig(id);
  const countryId = getCountryIdFromCookie();
  const isTester = getLocalStorageValue(LOCAL_STORAGE_KEYS.TESTER);

  if (countryId === 'RO' || isTester) {
    return (
      <CoreRegister
        id={id}
        componentsMap={registerStepsMap}
        isWithCloseButtonWrapper={true}
        classNames={{
          wrapperClassName: styles.wrapper,
          stepperWrapperClassName: styles.stepperContainer,
          stepsWrapperClassName: styles.stepsWrapper,
          closeIconClassName: styles.closeIcon,
          closeIconWrapperClassName: styles.closeIconWrapper
        }}
      />
    );
  }

  return (
    <GuestContent
      config={{
        ...config,
        isShowStepLine: false,
        steps: [{ type: 'closed' }]
      }}
      componentsMap={{ closed: RegistrationClosed }}
    />
  );
};

export default Register;
